// core components
import LoadingCard from "../../components/Loading/LoadingCard";
import React from "react";
import SystemNumberRedirect from "../../components/SystemNumberRedirect/SystemNumberRedirect.jsx";
import { connect } from "react-redux";
import { isLoading } from "../../stores/actions/actions";
import loginPageStyle from "../../../assets/jss/material-dashboard-pro-react/views/loginPageStyle";
import { Redirect } from 'react-router-dom'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

class LoadingPage extends React.Component {
  componentWillMount() {
    this.props.isLoading();
  }

  render() {
    const { classes } = this.props;

    if (this.props.isLoadingState) {
      return <LoadingCard classes={classes} title={"Loading"} />;
    } else {
      return <Redirect to={this.props.location.state?.from ? this.props.location.state.from : '/systems'} />;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    systems: state.dashboard.systems,
    isLoadingState: state.dashboard.isLoading,
  };
};

const actions = { isLoading };

const loadingPageWithStyles = withStyles(loginPageStyle)(LoadingPage);
export default connect(mapStateToProps, actions)(loadingPageWithStyles);
